/**
 * @generated by @interxfi/j5-codegen - do not edit */

import { buildMergedRequestInit, makeRequest } from '@interxfi/api-client/request';
import type { IxcRegistrationV1ProfileQueryServiceProfileGetProfileGetRequest, IxcRegistrationV1ProfileQueryServiceProfileGetResponse } from '@interxfi/types';

export const IXC_REGISTRATION_V1_PROFILE_QUERY_SERVICE_PROFILE_GET_AUDIENCE = ['clearing', 'program'];

export async function ixcRegistrationV1ProfileQueryServiceProfileGet(baseUrl: string | undefined, request?: IxcRegistrationV1ProfileQueryServiceProfileGetProfileGetRequest, requestInit?: RequestInit): Promise<IxcRegistrationV1ProfileQueryServiceProfileGetResponse | undefined> { return makeRequest<IxcRegistrationV1ProfileQueryServiceProfileGetResponse, IxcRegistrationV1ProfileQueryServiceProfileGetProfileGetRequest>(...buildMergedRequestInit('GET', baseUrl || '', '/ixc/registration/v1/profile/q/:profileId', request, requestInit)); }

